const en = {
  "page.home.title": "Home",
  "page.home.subtitle": "The Complete Transformation Guide from Zero to Macho",
  "nav.home": "Home",
  "nav.training": "Training Plans",
  "nav.diet": "Diet Plans",
  "nav.body": "Body Shaping",
  "nav.mental": "Mental Toughness",
  "nav.about": "About Us",
};

export default en;